/* @flow */

import PivotByLocationAction from "../actions/PivotByLocationAction";

import type {
    ClickAction,
    ClickActionProps
} from "platopulse/meta/types/Visualization";

export default (props: ClickActionProps): ClickAction[] => {
    return PivotByLocationAction(props);
};



// WEBPACK FOOTER //
// ./qb/components/drill/PivotByLocationDrill.jsx